import * as core from '../../../../../../../core'
import * as stakeholderProjectRole from '../stakeholder-project-role'

export const RESOURCE = {
  payload: {
    description: 'Steering Committee',
    enumId: core.dms.models.Enum.Id.from({
      partialId: stakeholderProjectRole.RESOURCE.payload.partialId,
    }),
    id: 'Steering Committee',
    name: 'Steering Committee',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
